module.exports = __webpack_public_path__ + "static/media/TBSCarharttFRMensPantsSizing.2230b5ad.pdf";